import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
// vuex持久化插件
import persistedstate from "vuex-persistedstate";

Vue.use(Vuex);
const modulesFiles = require.context("./modules", true, /\.js$/);
// console.log("modulesFiles", modulesFiles);
// 自动循环绑定modules内容
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  // 配置vuex持久化插件
  plugins: [
    persistedstate({
      paths: ["user", "globalData.rl_stdFlr_id", "detectionModule.rl_floor_id"],
    }),
  ],
});

export default store;
